import logo_breit from '../../assets/pictures/logos/it-liepert-logo_textunten_obgs.png'


import './MainFooter.css'
import './MMainFooter.css'


export default function MainFooter(props) {


    return (
        <div className='mainfooterdiv'>

            <div className='mainfooter'>

                <img src={logo_breit} alt="IT-Liepert Logo" />
                <div className='footerlinks'>
                    <a href='/impressum'>Impressum</a>
                    <a href='/datenschutz'>Datenschutz</a>
                    <a href='/barrierefreiheit'>Barrierefreiheit</a>
                </div>
                <div className='footercopyright'>
                    <span>©2026 it.liepert.gmbh</span>
                    <span className='footercopyright-credit'>
                        Webseite made by <a href="https://tonetwork.de" target="_blank" rel="noopener noreferrer">ToNetwork UG</a>
                    </span>
                </div>
            </div >
        </div >
    )
}